'use client';

import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { Dropdown, Icon } from '@benzinga/core-ui';
import { DEUFlag, ESPFlag, FRAFlag, ITAFlag, JPNFlag, KORFlag, USAFlag } from '@benzinga/icons';
import { appEnvironment } from '@benzinga/utils';
import { menus } from '../../menu-data';

const FLAGS: Record<string, typeof USAFlag> = {
  DEU: DEUFlag,
  ESP: ESPFlag,
  FRA: FRAFlag,
  ITA: ITAFlag,
  JPN: JPNFlag,
  KOR: KORFlag,
};

const EDITIONS = menus.globalMenu[0]?.subnav?.links ?? [];

export const LocaleMenu = () => {
  if (!appEnvironment().isApp()) return null;

  return (
    <div className="relative flex items-center px-3 before:absolute before:left-0 before:top-1/2 before:mt-[-7px] before:h-3.5 before:w-px before:bg-white/15 before:content-[''] after:absolute after:right-0 after:top-1/2 after:mt-[-7px] after:h-3.5 after:w-px after:bg-white/15 after:content-[''] max-[980px]:before:hidden">
      <Dropdown
        trigger="hover"
        placement="bottom-end"
        distance={8}
        topDivHeight={12}
        headless
        target={
          <button
            className="inline-flex h-[26px] cursor-pointer items-center gap-1.5 rounded-md border-0 bg-transparent px-2 font-[inherit] text-xs font-semibold tracking-[0.04em] text-[var(--hubnav-util-fg)] transition-colors duration-150 ease-out hover:bg-white/10 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--hubnav-accent)]"
            type="button"
            aria-label="Benzinga editions: United States"
          >
            <USAFlag className="h-3 w-[18px] flex-none rounded-sm shadow-[0_0_0_1px_rgba(255,255,255,0.16)]" />
            <span className="max-[980px]:hidden">US</span>
            <Icon className="flex flex-none leading-none opacity-70 [&>svg]:block [&>svg]:-translate-y-[10%]" icon={faChevronDown} />
          </button>
        }
      >
        <div className="relative flex min-w-[200px] flex-col rounded-xl border border-[var(--hubnav-line)] bg-[var(--hubnav-panel-bg)] p-1.5 shadow-[var(--hubnav-shadow)] before:absolute before:inset-x-0 before:-top-3 before:h-3 before:content-[''] [&_.flag]:shadow-[0_0_0_1px_rgba(0,0,0,0.1)]">
          <span
            className="flex min-h-9 cursor-default items-center gap-2.5 rounded-md px-2.5 text-[13px] font-semibold text-[var(--hubnav-fg)] no-underline hover:bg-transparent hover:text-[var(--hubnav-fg)]"
            aria-current="true"
          >
            <USAFlag className="flag h-3 w-[18px] flex-none rounded-sm" />
            United States
            <Icon className="ml-auto h-[11px] w-[11px] text-[var(--hubnav-accent)]" icon={faCheck} />
          </span>
          {EDITIONS.map(edition => {
            const Flag = FLAGS[edition.img_key ?? ''];
            return (
              <a
                className="flex min-h-9 items-center gap-2.5 rounded-md px-2.5 text-[13px] font-medium text-[var(--hubnav-fg)] no-underline transition-colors duration-100 ease-out hover:bg-[var(--hubnav-hover)] hover:text-[var(--hubnav-hover-text)]"
                href={edition.href}
                key={edition.href}
                rel="noreferrer"
                target="_blank"
              >
                {Flag ? <Flag className="flag h-3 w-[18px] flex-none rounded-sm" /> : null}
                {edition.label}
              </a>
            );
          })}
        </div>
      </Dropdown>
    </div>
  );
};
